import parseJwt from "@/util/parseJwt";

export const setCookie = (cname, cvalue, mode) => {
  const now = new Date();
  // convert epoch to ms and get different with now
  const epoch = parseJwt(cvalue)
  const diffTime = Math.abs(new Date(epoch.exp) - now);
  now.setTime(now.getTime() + diffTime);
  let expires = "expires=" + now.toUTCString();
  if (mode === 'development') {
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  } else {
    document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=htop.stechoq.com;path=/";
  }
}

export const getCookie = (cname) => {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export const delCookie = function deleteCookie(cName) {
  if (process.env.NODE_ENV === 'development') {
    document.cookie = `${cName}=;expires=;path=/`
  } else {
    document.cookie = `${cName}=;expires=;domain=htop.stechoq.com;path=/`
  }
};